import $ from 'jquery';

$(function() {
    var bankDetailsData = null;
    var iBankDetailsData = null;

    $("#cwm_bd_sortCode").mask("00-00-00");
        //hiding edit form 
    $('.cwm-editviewdeatails-form').hide();
    // close button 
	$("#cwm-editbankDetails-formClose" ).on( "click", function() { 
        window.location.reload();
	});	
    
	// enable and disable submit button
	$('#bankDetails_editForm input.my-account_formControl').on('keyup',function() {
		if($("#cwm_bd_nameOfBank").val() != '' || $("#cwm_bd_nameOnAccount").val() != '' ||
        $("#cwm_bd_accountNumber").val() != '' || $("#cwm_bd_sortCode").val() != '' ||
        $("#cwm_bd_bankAddress").val() != '' || $("#cwm_bd_bankpostCode").val() != '') {
			$('#mybankDetailsedit-form').attr('disabled' , false);
		}else{
			$('#mybankDetailsedit-form').attr('disabled' , true);
		}
	});
    //for small to uppercase letters
    $('#cwm_bd_bankpostCode').keyup(function() {
        this.value = this.value.toLocaleUpperCase();
    });
    $('#cwm_Intbank_postCode').keyup(function() {
        this.value = this.value.toLocaleUpperCase();
    });
    $('#cwm_Intbank_bic').keyup(function() {
        this.value = this.value.toLocaleUpperCase();
    });
	// International Bank enable and disable submit button
	$('#cwm-internationalbank-form input.my-account_formControl').on('keyup',function() {
		if($("#cwm_Intbank_nameOnAccount").val() != '' || $("#cwm_Intbank_Accountnum").val() != '' ||
        $("#cwm_Intbank_iban").val() != '' || $("#cwm_Intbank_bic").val() != '' ||
        $("#cwm_Intbank_bankName").val() != '' || $("#cwm_Intbank_houseName").val() != '' ||
        $("cwm_Intbank_postCode").val() != '') {
			$('#cwm_IntbankSubmit-form').attr('disabled', false);
		} else {
			$('#cwm_IntbankSubmit-form').attr('disabled', true);
		}
	}); 

    //Edit Bank details form: ajax request
	$('#mybankDetailsedit-form').on( "click", function() { 
        
       // assigning Bank details form values and names in to var
		    bankDetailsData = {
                BankName: $("#cwm_bd_nameOfBank").val(),
                NameOfAccountHolder: $("#cwm_bd_nameOnAccount").val(),
                AccountNumber: $("#cwm_bd_accountNumber").val(),
                SortCode: $("#cwm_bd_sortCode").val(),
                AddressLine1: $("#cwm_bd_bankAddress").val(),
                PostCode: $("#cwm_bd_bankpostCode").val(),
                BankDetailType: 0,
                BankDetailId: $("#BankDetailId").val(),
                BankAddressId: $("#BankAddressId").val(),
                AccountName: $("#cwm_bd_nameOnAccount").val(),
            };
            
        //onlynumbers and Uppercase letters
		$.validator.addMethod("postalcode", function(value, element) {
			return this.optional(element) || value == value.match(/^[A-Z0-9\s]*$/);
		});
        
        $("#bankDetails_editForm").validate({ 
            wrapper: 'span',
            errorPlacement: function (error, element) {
				error.addClass("my-account_errorlabel")
				error.insertAfter(element);
			},
            rules: {
                cwm_bd_nameOfBank: {
                    maxlength: 255,
                },
                cwm_bd_bankAddress:  {
                    maxlength: 255,
                },
                cwm_bd_bankpostCode: {
                    postalcode:true,
					maxlength: 8
                },
                cwm_bd_nameOnAccount: {  
                    required: true,
                    maxlength: 255 
				},
                cwm_bd_accountNumber: {           
					required: true,
                    number: true,
                    maxlength: 8,
                    minlength:8
				},
                cwm_bd_sortCode: {           
					required: true,
                    minlength: 8,
                    maxlength: 8
                    
				},
            },
            messages: {  
                cwm_bd_nameOfBank: {
                    maxlength: "Please enter no more than 255 characters.",
                },
                cwm_bd_bankAddress: {
                    maxlength: "Please enter no more than 255 characters."
                },
                cwm_bd_bankpostCode: {
                    postalcode: "Please enter a valid postcode.",
					maxlength: "Please enter no more than 8 characters."
                },
                cwm_bd_nameOnAccount: {           
                    required: "Please enter name on account.",
                    maxlength: "Please enter no more than 255 characters."
                },
                cwm_bd_accountNumber: {           
                    required: "Please enter account number.",
                    number: "Please enter a valid account number.",
                    minlength: "Please enter a valid account number.",
                    maxlength: "Please enter no more than 8 characters."
                },
                cwm_bd_sortCode: {           
					required: "Please enter sort code.",
                    minlength: "Please enter a valid sortcode.",
                    maxlength: "Please enter a valid sortcode."                   
				},
            },

            submitHandler: function(form) { 
                $('html').css({ 'overflow-y': "hidden" });
				$("#cwm-overlay").show();
				$.ajax({
                    url: form.action,
                    type: form.method,
                    data: bankDetailsData,
                    dataType: "json",
                    success: function (response) {  
                        $('html').css({ 'overflow-y': "scroll" });
						$("#cwm-overlay").hide();
                        $(".cwm-status-msg__container.status-success").css('display', 'flex').delay(3000).queue(function(n) {
                            $(this).hide(); n();  
                            $('.cwm-view-details').show();
                            window.location.reload();                          
                        });
                        $('html,body').animate({
                            scrollTop: $(".cwm-status-msg__container").offset().top - 300},'1000');
                        $('html,body').animate({
                                scrollTop: $(".cwm-view-details.view-bankdetails'").offset().top - 300},'1000'); 
                    },
                    error: function (response) {
                        $('html').css({ 'overflow-y': "scroll" });
						$("#cwm-overlay").hide();
                        console.log(response.success);                       
                        $(".cwm-status-msg__container.status-error").css('display', 'flex').delay(3000).queue(function(n)
                         { 
                             $(this).hide(); n(); 
                        });  
                        $('html,body').animate({
                            scrollTop: $(".cwm-status-msg__container").offset().top - 300},'1000');
                    }           
				});
			}
        });
    });
 
    $("#cwm_Intbank_Accountnum").keyup(function() {
        if($("#cwm_Intbank_Accountnum").val().length != '' || $("#cwm_Intbank_iban").val().length != '') {
            $("#cwm_Intbank_iban").removeClass('error');
            $('#cwm_Intbank_iban-error').hide();
            $('#cwm_Intbank_iban-error').parent('span.my-account_errorlabel').hide();
        }
    });
    $("#cwm_Intbank_iban").keyup(function() {
        if($("#cwm_Intbank_Accountnum").val().length != '' || $("#cwm_Intbank_iban").val().length != '') {
            $("#cwm_Intbank_Accountnum").removeClass('error');
            $("#cwm_Intbank_Accountnum-error").hide();
            $("#cwm_Intbank_Accountnum-error").parent().hide();
        }
    });
    //International Bank Edit Bank details form: ajax request
    $('#cwm_IntbankSubmit-form').on( "click", function() {
       
        iBankDetailsData = {
            BankName: $("#cwm_Intbank_bankName").val(),
            NameOfAccountHolder:  $("#cwm_Intbank_nameOnAccount").val(),
            AccountNumber: $("#cwm_Intbank_Accountnum").val(),
            Iban: $("#cwm_Intbank_iban").val(),
            Swift_Bic_Code: $("#cwm_Intbank_bic").val(),
            AddressLine1: $("#cwm_Intbank_houseName").val(),
            PostCode: $("#cwm_Intbank_postCode").val(),
            BankDetailType: 1,
            BankDetailId: $("#BankDetailId").val(),
            BankAddressId: $("#BankAddressId").val(),
            AccountName: $("#cwm_Intbank_nameOnAccount").val(),
        }
        
         //onlynumbers and Uppercase letters and symbol/^[A-Z0-9\s]*$/
		$.validator.addMethod("postalcode", function(value, element) {
			return this.optional(element) || value == value.match(/^[A-Z0-9 -_]*$/);
		});
        //only accept letters and numbers 
		$.validator.addMethod("bicletters", function(value, element) {
			return this.optional(element) || value == value.match(/^[a-zA-Z0-9\s]*$/);
		});
        
        $("#cwm-internationalbank-form").validate({ 
            wrapper: 'span',
            errorPlacement: function (error, element) {
				error.addClass("my-account_errorlabel")
				error.insertAfter(element);
			},
            rules: {
                cwm_Intbank_nameOnAccount: {  
                    required: true,
                    maxlength: 255 
				},
                cwm_Intbank_bic: {
                    required: true,
                    bicletters: true,
                    maxlength: 11 
                },
                cwm_Intbank_Accountnum: {
                    required: function(element) {
                    if($("#cwm_Intbank_Accountnum").val() == '' && $("#cwm_Intbank_iban").val() == '' ) { 
                        return true;
                    } else {
                        return false;
                    }
                },
                    maxlength: 20,
                    number: true
                },
                cwm_Intbank_iban: {
                    required: function(element) {
                        if($("#cwm_Intbank_Accountnum").val() == '' && $("#cwm_Intbank_iban").val() == '' ) { 
                            return true;
                        } else {
                            return false;
                        }
                    },
                    maxlength: 34,
                    number: true
                },
                cwm_Intbank_bankName: {
                    maxlength: 255,
                },
                cwm_Intbank_houseName: {
                    maxlength: 255
                },
                cwm_Intbank_postCode: {
                    postalcode:true,
					maxlength: 12
                }
            },
            messages: {  
                cwm_Intbank_nameOnAccount: {           
                    required: "Please enter name on account.",
                    maxlength: "Please enter no more than 255 characters."
                },
                cwm_Intbank_bic: {
                    required: "Please enter SWIFT/BIC/Routing number.",
                    bicletters: "Please enter a valid SWIFT/BIC/Routing number.",
                    maxlength: "Please enter no more than 11 characters."
                },
                cwm_Intbank_Accountnum: {
                    maxlength: "Please enter no more than 20 characters.",
                    number: "Please enter a valid account number.",
                    required: "Please enter either IBAN or account number."
                },
                cwm_Intbank_iban: {
                    required: "Please enter either IBAN or account number.",
                    maxlength: "Please enter no more than 34 characters.",
                    number: "Please enter a valid IBAN numbers."
                },
                cwm_Intbank_bankName: {
                    maxlength: "Please enter no more than 255 characters.",
                },
                cwm_Intbank_houseName: {
                    maxlength: "Please enter no more than 255 characters."
                },
                cwm_Intbank_postCode: {
                    postalcode: "Please enter a valid postcode/zipcode.",
					maxlength: "Please enter no more than 12 characters."
                }
            },

            submitHandler: function(form) {
                $('html').css({ 'overflow-y': "hidden" });
				$("#cwm-overlay").show();
				$.ajax({
                    url: form.action,
                    type: form.method,
                    data: iBankDetailsData,
                    dataType: "json",
                    success: function (response) { 
                        $('html').css({ 'overflow-y': "scroll" });
						$("#cwm-overlay").hide();
                        $(".cwm-status-msg__container.status-success").css('display', 'flex').delay(3000).queue(function(n) {
                            $(this).hide(); n();  
                            $('.cwm-view-details').show();
                            window.location.reload();                          
                        });
                        $('html,body').animate({
                            scrollTop: $(".cwm-status-msg__container").offset().top - 300},'1000'); 
                        $('html,body').animate({
                                scrollTop: $('.cwm-view-details.view-bankdetails').offset().top - 300},'1000');
                       
                    },
                    error: function (response) {   
                        $('html').css({ 'overflow-y': "scroll" });
						$("#cwm-overlay").hide();                      
                        console.log(response.success);
                        $(".cwm-status-msg__container.status-error").css('display', 'flex').delay(3000).queue(function(n)
                         { 
                             $(this).hide(); n(); 
                        });  
                        $('html,body').animate({
                            scrollTop: $(".cwm-status-msg__container").offset().top - 300},'1000'); 
                    }           
				});
			}
        });
       
    });
});


// WEBPACK FOOTER //
// ./components/cwm-editmybank-details/scripts/editmybank-details.js